import React from 'react';
import PropTypes from 'prop-types';
import '@purple/semantic-ui-purple-theme/components/rating.css';

/**
 * This component is a replacement for a <Rating disabled /> component.
 * This component exists because of this issue that was discovered during a11y fixes:
 * https://github.com/Semantic-Org/Semantic-UI-React/issues/3252
 */
export default class RatingDisplayOnly extends React.PureComponent {
  static propTypes = {
    rating: PropTypes.number.isRequired,
    maxRating: PropTypes.number.isRequired,
  };

  render() {
    const { rating, maxRating } = this.props;
    const icons = [];
    let checked = false;
    for (let i = 1; i <= maxRating; i += 1) {
      checked = i <= rating;
      icons.push(
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        <i
          key={i}
          aria-checked={checked}
          aria-posinset={i}
          aria-setsize={maxRating}
          className={checked ? 'active icon' : 'icon'}
          role="radio"
        />,
      );
    }

    return (
      <div className="ui disabled rating" role="radiogroup">{icons}</div>
    );
  }
}
